import React from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../common/GridLayout";

import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Pager,
    LoadPanel,
    Export,
    ColumnHeaderFilter,
    ColumnChooser,
    ColumnChooserSearch,
    HeaderFilter,
    ColumnFixing,
    Scrolling,
    StateStoring,
} from "devextreme-react/data-grid";
let detailInDataGrid = React.createRef();
let accessToken = '';
const gridKey = "A0158C8D-A656-45DD-BDF6-C26436FF5473";
const statusLookup = [
    { ID: 'O', Text: "Open" },
    { ID: 'H', Text: "Hold" },
    { ID: 'L', Text: "Ready To Commit Later" },
    { ID: 'N', Text: "Ready To Commit Now" },
];
const toStage = [
    { ID: 'L', Text: 'Canceled - No Inventory Effect' },
    { ID: 'Q', Text: 'Quote - No Inventory Effect' },
    { ID: 'P', Text: 'Plan - No Inventory Effect' },
    { ID: 'F', Text: 'Future - No Effect on Net Available' },
    { ID: 'N', Text: 'Pending - Effects Net Available' },
    { ID: 'A', Text: 'Assigned - Effects Available' },
    { ID: 'S', Text: 'Picked/Staged - Effects Available' },
    { ID: 'C', Text: 'Shipped/Completed - Effects Available' }
];
class UpdateOrderDetailLotGridPreview extends React.Component {

    constructor(props) {
        super(props);
        accessToken = props.oidc.user.access_token;

        this.state = {
            records: 0
        }
        this.loadState = this.loadState.bind(this);
        this.saveState = this.saveState.bind(this);
    }

    loadState() {
        // const { gridKey, accessToken } = this.state;
        return GridLayout.sendStorageRequest(gridKey, "GET", accessToken);
    }

    saveState(state) {
        GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state);
    }
    render() {
        return (
            <div className="row" style={{ height: '100%', width: '100%' }}>
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                    dataSource={this.props.dataSource}
                    showBorders={true}
                    ref={detailInDataGrid}
                    className="customDataTableDesignCommit"
                    hoverStateEnabled={true}
                    allowColumnResizing={true}
                    allowColumnReordering={true}
                    columnAutoWidth={true}
                    showRowLines={true}
                    style={{ height: '100%', width: '100%' }}
                //onContentReady={this.DetailInGridContentReady}
                >
                    <Scrolling mode="virtual" useNative={false} />
                    <ColumnChooser
                        enabled={true}
                        title="Choose Column"
                        width={290}
                        height={290}
                        sortOrder="asc"
                    >
                        <ColumnChooserSearch
                            enabled={true}
                            editorOptions={{ placeholder: 'Search column' }} />
                    </ColumnChooser>
                    <ColumnFixing enabled={true} />
                    <ColumnHeaderFilter />
                    <Export enabled={true} allowExportSelectedData={true} text="Export" />
                    <Sorting visible={true} mode="multiple" />
                    <LoadPanel enabled={true} />
                    <Paging defaultPageSize={100} />
                    <Pager
                        visible={true}
                        showPageSizeSelector={true}
                        allowedPageSizes={[10, 20, 50, 500, 1000, "all"]}
                        showNavigationButtons={true}
                    />
                    <FilterRow visible={true} />
                    <FilterPanel visible={true} />
                    <HeaderFilter />
                    <GroupPanel visible={true} />
                    <Grouping autoExpandAll={false} />
                    <StateStoring
                        enabled={true}
                        type="custom"
                        customLoad={this.loadState}
                        storageKey={gridKey}
                        customSave={this.saveState}
                    />
                     <Column dataField="recordNumber" caption="Record #" dataType="string" />
                    <Column dataField="customerId" caption="Customer ID" dataType="string" />
                    <Column dataField="transactionNumber" caption="Transaction #" dataType="string" />
                    <Column dataField="transactionDate" caption="Transaction Date" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" />
                    <Column dataField="shipToID" caption="Ship To" dataType="string" />
                    <Column dataField="shipViaID" caption="Ship Via" dataType="string" />
                    <Column dataField="shippingDate" caption="Shipping Date" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" />
                    <Column dataField="purchaseOrderNumber" caption="PO Number" dataType="strng" />
                    <Column dataField="reference" caption="Reference #" />
                    <Column dataField="equipmentId" caption="Equipment" dataType="string" />
                    <Column dataField="invoiceDate" caption="Invoice Date" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" />
                    <Column dataField="transactionDueDate" caption="Transaction Due Date" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" />
                    <Column dataField="discountType" caption="Discount Type" dataType="string" />
                    <Column dataField="orderSignedFlag" caption="Order Signed" dataType="string" />
                    <Column dataField="truckReference" caption="Truck Reference" dataType="string" />
                    <Column dataField="truckDepartDateTime" caption="Truck Departure DateTime" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" />
                    <Column dataField="truckArrivalDateTime" caption="Truck Arrival DateTime" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" />
                    <Column dataField="printInvoice" caption="Print Invoice" dataType="string" />
                    <Column dataField="printBOL" caption="Print BOL" dataType="string" />
                    <Column dataField="printDeliveryNotification" caption="Print Delivery Verification" dataType="string" />
                    <Column dataField="printOrderAcknowledgement" caption="Print Order Acknowledgement" dataType="string" />
                    <Column dataField="sendFax" caption="Send Fax" dataType="string" />
                    <Column dataField="sendEmail" caption="Send Email" dataType="string" />
                    <Column dataField="cancelDate" caption="Cancel Date" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" />
                    <Column dataField="status" caption="Status" dataType="string" />
                    <Column dataField="discountPercent" caption="Discount %" dataType="number" format="#0.00" />
                    <Column dataField="partialShipment" caption="Partial Shipment" dataType="string" />
                    <Column dataField="creditReviewDate" caption="Credit Review Date" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" />
                    <Column dataField="salesMethod" caption="Sales Method" dataType="string" />
                    <Column dataField="fiscalPeriod" caption="FP" dataType="string" />
                    <Column dataField="fiscalYear" caption="FY" dataType="string" />
                    <Column dataField="profileCode" caption="Profile Code" dataType="string" />
                    <Column dataField="description" caption="Profile Description" dataType="string" />
                    <Column dataField="customerIdGroup" caption="Customer ID Group" dataType="string" />
                    <Column dataField="customerIdSubGroup" caption="Customer ID SubGroup" dataType="string" />
                    <Column dataField="customerCode1" caption="Customer Code 1" dataType="string" />
                    <Column dataField="customerCode2" caption="Customer Code 2" dataType="string" />
                    <Column dataField="customerCode3" caption="Customer Code 3" dataType="string" />
                    <Column dataField="customerCode4" caption="Customer Code 4" dataType="string" />
                    <Column dataField="customerCode5" caption="Customer Code 5" dataType="string" />
                    <Column dataField="customerCode6" caption="Customer Code 6" dataType="string" />
                    <Column dataField="customerCode7" caption="Customer Code 7" dataType="string" />
                    <Column dataField="customerCode8" caption="Customer Code 8" dataType="string" />
                    <Column dataField="customerCode9" caption="Customer Code 9" dataType="string" />
                    <Column dataField="customerCode10" caption="Customer Code 10" dataType="string" />
                    <Column dataField="shipperId" caption="Shipper ID" dataType="string" />




                </DataGrid>
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(UpdateOrderDetailLotGridPreview);